var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt20", staticStyle: { padding: "0 88px 60px" } },
    [
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          [
            _c("el-input", {
              attrs: { placeholder: "订单号查询", clearable: "" },
              model: {
                value: _vm.queryData.orderNo,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "orderNo", $$v)
                },
                expression: "queryData.orderNo",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: {
                  placeholder: "平台类型",
                  filterable: "",
                  clearable: "",
                },
                model: {
                  value: _vm.queryData.platform,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "platform", $$v)
                  },
                  expression: "queryData.platform",
                },
              },
              [
                _c("el-option", { attrs: { value: "TB", label: "淘宝" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "JD", label: "京东" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "PDD", label: "拼多多" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "WPH", label: "唯品会" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "MT", label: "美团" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "ELM", label: "饿了么" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "KS", label: "快手" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "DY", label: "抖音" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "DD", label: "滴滴" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "OT", label: "在线点单" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: "QF", label: "直充卡券" } }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { value: "TXYX", label: "腾讯云选" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "订单状态", clearable: "" },
                model: {
                  value: _vm.queryData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "status", $$v)
                  },
                  expression: "queryData.status",
                },
              },
              [
                _c("el-option", { attrs: { value: 1, label: "已支付" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 2, label: "已取消" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 3, label: "已结算" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 4, label: "已收货" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.queryData.type !== 1
          ? _c(
              "div",
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "订单类型", clearable: "" },
                    model: {
                      value: _vm.queryData.grade,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryData, "grade", $$v)
                      },
                      expression: "queryData.grade",
                    },
                  },
                  [
                    _c("el-option", { attrs: { value: 0, label: "正常订单" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { value: 1, label: "违规订单" } }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex", staticStyle: { width: "fit-content" } },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                attrs: { type: "info", plain: "" },
                on: { click: _vm.onReset },
              },
              [_vm._v("重置")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex mt10",
          staticStyle: {
            "align-items": "center",
            "margin-bottom": "15px",
            "margin-left": "5px",
          },
        },
        [
          _vm._l(_vm.statusTypeData, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "fc type_button pointer",
                class:
                  _vm.statusTypeDataIndex === item.id ? "selector_button" : "",
                on: {
                  click: function ($event) {
                    return _vm.onStatusList(item, index)
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _vm.statusTypeDataIndex === 6
            ? _c(
                "div",
                { staticStyle: { width: "360px", height: "40px" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      align: "right",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    on: { change: _vm.changeDataPicker },
                    model: {
                      value: _vm.value1,
                      callback: function ($$v) {
                        _vm.value1 = $$v
                      },
                      expression: "value1",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt10" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "商品信息", width: "500" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "flex" }, [
                          _c("div", [
                            _c("img", {
                              staticStyle: {
                                width: "50px",
                                height: "50px",
                                "border-radius": "4px",
                              },
                              attrs: { src: scope.row.img, alt: "" },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml10" }, [
                            _c("div", [
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "TB",
                                    expression: "scope.row.platform=== 'TB'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/tb.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "JD",
                                    expression: "scope.row.platform=== 'JD'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/jd.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "PDD",
                                    expression: "scope.row.platform=== 'PDD'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/pdd.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "WPH",
                                    expression: "scope.row.platform=== 'WPH'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/wph.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "DY",
                                    expression: "scope.row.platform=== 'DY'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/dy.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "KS",
                                    expression: "scope.row.platform=== 'KS'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/ks.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "ELM",
                                    expression: "scope.row.platform=== 'ELM'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/elm.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.platform === "MT",
                                    expression: "scope.row.platform=== 'MT'",
                                  },
                                ],
                                staticClass: "icon_img",
                                attrs: {
                                  alt: "",
                                  src: require("@/assets/platformIcon/mt.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "ellipsis-multiline" },
                                [_vm._v(_vm._s(scope.row.title))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "frb",
                                staticStyle: { "margin-top": "4px" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "订单号：" +
                                        _vm._s(scope.row.orderNo) +
                                        "  "
                                    ),
                                    _c("img", {
                                      staticStyle: {
                                        width: "20px",
                                        height: "20px",
                                        "margin-left": "10px",
                                      },
                                      attrs: {
                                        src: require("@/assets/copy_icon.png"),
                                        alt: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyText(scope.row.orderNo)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mr10" }, [
                                  _vm._v(
                                    "付款金额：¥" + _vm._s(scope.row.payAmount)
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "订单状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 1
                          ? _c("span", [_vm._v("已支付")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 2
                          ? _c("span", [_vm._v("已取消")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 3
                          ? _c("span", [_vm._v("已结算")])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 4
                          ? _c("span", [_vm._v("已收货")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "commissionRate",
                  label: "佣金比例",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "commission",
                  label: "预估佣金",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "payTime", label: "支付时间", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyTime",
                  label: "确认收货时间",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "date", label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleClick(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20 page_box" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryData.page.page,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.queryData.page.size,
              layout: "total, prev, pager, next, sizes,jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }